/**
 * Which Firebase project this build talks to (#183).
 *
 * Until this existed there was exactly one config file, so a build made for
 * staging still opened Auth, Firestore, Functions and Storage against
 * PRODUCTION. Every staging login created a real user; every staging save
 * wrote a real document. The hosting site was separate, the data was not.
 *
 * The environment is decided at build time by `REACT_APP_ENV` (see
 * `environment.js`), and the config is picked from it here — one place, not
 * scattered `IS_STAGING` checks. A missing or unknown value falls back to
 * production, which is the only safe direction to fail: a production build
 * that accidentally read the staging config would lose every user's data.
 *
 * These values are not secrets. A Firebase web config ships inside every
 * bundle by design; what protects the data is `firestore.rules` plus Auth.
 */

import { APP_ENV } from '../environment'

import productionConfig from './config.json'
import stagingConfig from './config.staging.json'

const CONFIG_BY_ENV = {
  production: productionConfig,
  staging: stagingConfig,
}

export const firebaseConfig = CONFIG_BY_ENV[APP_ENV] || productionConfig

export default firebaseConfig
